module.exports = __webpack_public_path__ + "img/课表.d896fbc6.svg";